import React from 'react';
import { useTranslation } from 'react-i18next';
const CascadeKrList = (props) => {
    const krItem = props.cascadeKrItem;
    const firstname = props.cascadeObjOwner;
    const { objId, hasAccess } = props;
    const { t } = useTranslation()
    return (
        <div className="cascadeUpdateKeyList">
            <div className="cascadeUpdateLink cascadeUpdateSemibold" style={{ cursor: (hasAccess) ? 'pointer' : 'default' }} onClick={() => props.goalDetPage(objId, krItem.id, hasAccess)}>
                {krItem.name}
            </div>
            <div className="cascadeUpdateMessage">
                {t('Note from')}
        {' '}
                {firstname}
:
        {' '}
                {krItem.message}
            </div>
        </div>
    );
}

export default CascadeKrList;